import { useEffect, useState } from 'react';
import { getElapsedTimeLabel } from '../../../utils/dateUtils';

function useElapsedTime(startTime?: string | null): string {
  const [elapsed, setElapsed] = useState<string>(() => getElapsedTimeLabel(startTime));

  useEffect(() => {
    setElapsed(getElapsedTimeLabel(startTime));
    const interval = setInterval(() => {
      setElapsed(getElapsedTimeLabel(startTime));
    }, 1000);

    return () => clearInterval(interval);
  }, [startTime]);

  return elapsed;
}

export default useElapsedTime;
